import {
    COMPETITIONS_PATCH_FAILURE,
    COMPETITIONS_PATCH_REQUEST,
    COMPETITIONS_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export const competitionPatchReducer = (state = initialState, action) => {
    const {type, competition} = action;
    switch (type) {
        case COMPETITIONS_PATCH_SUCCESS: {return {
            ...initialState,
            competition,
        }}

        case COMPETITIONS_PATCH_REQUEST: {return {
            ...initialState,
            patching: true,
        }}

        case COMPETITIONS_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: { return state }
    }
};
